import React from 'react'
import { useTranslation } from 'react-i18next'
import i18n from '@src/i18n'

import Hero from '../../components/Hero'
import Article from '../../components/Article'
import Section from '../../components/Section'

export interface QuickbooksProps {}

const HERO_IMAGE = '/paywalls/qbo/hero.png'

const ARTICLES = [
  {
    title: i18n.t('paywalls:quickbooks.articles.po.title'),
    text: i18n.t('paywalls:quickbooks.articles.po.text'),
    image: '/paywalls/qbo/po.png',
  },
  {
    title: i18n.t('paywalls:quickbooks.articles.approval.title'),
    text: i18n.t('paywalls:quickbooks.articles.approval.text'),
    image: '/paywalls/qbo/approval.png',
  },
  {
    title: i18n.t('paywalls:quickbooks.articles.audit.title'),
    text: i18n.t('paywalls:quickbooks.articles.audit.text'),
    image: '/paywalls/qbo/audit.png',
  },
]

export const Quickbooks: React.FC<QuickbooksProps> = () => {
  const { t } = useTranslation('paywalls', { keyPrefix: 'quickbooks' })
  return (
    <>
      <Hero title={t('hero.title')} image={HERO_IMAGE} subtitle={t('hero.subtitle')} />
      <Section title={t('section.title')} text={t('section.text')} />
      <div className="flex flex-col gap-6">
        {ARTICLES.map((article, index) => (
          <Article
            key={article.title}
            title={article.title}
            image={article.image}
            text={article.text}
            hasActionButtons={index === ARTICLES.length - 1}
          />
        ))}
      </div>
    </>
  )
}

export default Quickbooks
